/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const WelcomeIcon = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <g id="freepik--background-complete--inject-107">
        <path
          d="M366.71,175.42l-40.6,19.26,74,17.18L372,176.63A4.36,4.36,0,0,0,366.71,175.42Z"
          style={{ fill: '#e0e0e0' }}
        />
        <path
          d="M320.47,202.73H396a.37.37,0,0,1,.37.37v43.14a.89.89,0,0,1-.89.89H321a.89.89,0,0,1-.89-.89V203.1A.37.37,0,0,1,320.47,202.73Z"
          transform="translate(60.14 -75.18) rotate(13.07)"
          style={{ fill: '#e0e0e0' }}
        />
        <path
          d="M395.31,211.81l-34.73,11.68L330,198.11l5.39-20.32a4.14,4.14,0,0,1,5-3l56.26,13.05a4.16,4.16,0,0,1,3.1,5Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M358.38,220.05l-41.57,14.5h0a3.39,3.39,0,0,0,2.54,4.07l67.73,15.72a3.39,3.39,0,0,0,4.07-2.54l.06-.25L362.14,221A3.58,3.58,0,0,0,358.38,220.05Z"
          style={{ fill: '#e0e0e0' }}
        />
        <rect
          x="340.39"
          y="187.1"
          width="22.59"
          height="2.31"
          transform="translate(51.65 -74.62) rotate(13.06)"
          style={{ fill: '#e0e0e0' }}
        />
        <rect
          x="338.68"
          y="195.91"
          width="50.13"
          height="2.61"
          transform="translate(53.99 -77.11) rotate(13.06)"
          style={{ fill: '#f5f5f5' }}
        />
        <rect
          x="337.24"
          y="202.11"
          width="50.13"
          height="2.61"
          transform="translate(55.35 -76.63) rotate(13.06)"
          style={{ fill: '#f5f5f5' }}
        />
        <polygon
          points="384.21 215.56 382.16 216.23 340.93 207.18 336.75 203.64 336.83 203.04 385.5 214.33 385.31 215.17 384.21 215.56"
          style={{ fill: '#f5f5f5' }}
        />
        <polygon
          points="370.07 220.29 351.6 216.01 347.18 212.31 374.78 218.71 370.07 220.29"
          style={{ fill: '#f5f5f5' }}
        />
        <path
          d="M356.86,220.58a9.13,9.13,0,0,1-1.55.64L351,222.77c-3.64,1.29-8.67,3-14.24,4.93s-10.63,3.59-14.3,4.79l-4.34,1.4a9,9,0,0,1-1.62.44,11,11,0,0,1,1.55-.64l4.3-1.55c3.64-1.29,8.67-3,14.24-4.93s10.62-3.59,14.29-4.79l4.35-1.39A11.44,11.44,0,0,1,356.86,220.58Z"
          style={{ fill: '#ebebeb' }}
        />
        <path
          d="M391.21,251.55c-.1.1-6.38-6.33-14-14.35s-13.76-14.61-13.65-14.71,6.38,6.32,14,14.35S391.32,251.45,391.21,251.55Z"
          style={{ fill: '#ebebeb' }}
        />
        <path
          d="M397,211.24a8.25,8.25,0,0,1-1.26.57c-.82.33-2,.8-3.5,1.36-3,1.12-7.08,2.61-11.65,4.18s-8.75,2.91-11.78,3.84c-1.52.46-2.75.83-3.6,1.06a6.33,6.33,0,0,1-1.34.32,7.61,7.61,0,0,1,1.28-.51l3.55-1.22,11.72-4,11.7-4,3.55-1.2A7.28,7.28,0,0,1,397,211.24Z"
          style={{ fill: '#ebebeb' }}
        />
        <path
          d="M356.86,220.58a9.8,9.8,0,0,1-1.25-1l-3.3-2.76-11-9c-4.3-3.51-8.16-6.73-10.89-9.14-1.37-1.2-2.47-2.18-3.21-2.88a8.07,8.07,0,0,1-1.11-1.13,11.19,11.19,0,0,1,1.25,1l3.3,2.76,11,9c4.3,3.51,8.16,6.74,10.89,9.14,1.37,1.2,2.47,2.19,3.21,2.89A8.45,8.45,0,0,1,356.86,220.58Z"
          style={{ fill: '#ebebeb' }}
        />
        <path
          d="M395.31,211.81a1.58,1.58,0,0,1,0-.29c0-.21.1-.49.17-.83.16-.76.39-1.82.68-3.16l2.62-11.63q.21-.93.42-1.89a13.29,13.29,0,0,0,.38-1.94,3.9,3.9,0,0,0-1.74-3.47,5.14,5.14,0,0,0-2-.74l-2.27-.52-4.74-1.09-21.09-4.87-21.09-4.92-4.74-1.11a19.94,19.94,0,0,0-2.24-.47,3.93,3.93,0,0,0-3.57,1.81,6.15,6.15,0,0,0-.7,1.91c-.36,1.32-.7,2.59-1,3.81l-3.14,11.5c-.37,1.33-.66,2.37-.88,3.12q-.14.5-.24.81a.86.86,0,0,1-.1.27s0-.1.05-.29l.19-.82c.19-.75.45-1.8.79-3.14.71-2.76,1.72-6.7,3-11.54.32-1.22.65-2.5,1-3.82a6.48,6.48,0,0,1,.74-2,4.33,4.33,0,0,1,1.66-1.54,4.28,4.28,0,0,1,2.29-.49,21.63,21.63,0,0,1,2.32.46l4.74,1.09,21.09,4.88L389,185.79l4.73,1.11,2.27.53a5.62,5.62,0,0,1,2.17.81,4.33,4.33,0,0,1,1.9,3.85,13.49,13.49,0,0,1-.4,2c-.15.64-.3,1.27-.45,1.88-1.16,4.87-2.11,8.82-2.77,11.59l-.78,3.15c-.09.33-.16.6-.22.81A1.09,1.09,0,0,1,395.31,211.81Z"
          style={{ fill: '#e0e0e0' }}
        />
        <polygon
          points="299.51 92.66 368.76 79.78 379.11 126.58 307.19 138.73 299.51 92.66"
          style={{ fill: '#ebebeb' }}
        />
        <path
          d="M368.76,79.78s0,.07-.12.2l-.39.54-1.54,2.06L361,90.12C356,96.49,349.22,105.26,341.68,115l-.13.17-.2-.1-1.34-.71L311.32,99.11l-8.67-4.67-2.34-1.3-.6-.35a.82.82,0,0,1-.2-.13.67.67,0,0,1,.22.09l.63.3,2.39,1.21,8.74,4.53c7.4,3.88,17.55,9.22,28.76,15.12l1.35.71-.33.07L360.66,89.9l5.89-7.44,1.62-2,.43-.51A.84.84,0,0,1,368.76,79.78Z"
          style={{ fill: '#e0e0e0' }}
        />
        <path
          d="M307.19,138.73c-.12-.08,4.33-7.14,9.94-15.77s10.27-15.57,10.39-15.49-4.33,7.14-9.95,15.77S307.31,138.81,307.19,138.73Z"
          style={{ fill: '#e0e0e0' }}
        />
        <path
          d="M379.11,126.58c-.09.11-6.57-4.85-14.47-11.07S350.41,104.13,350.49,104s6.57,4.85,14.47,11.08S379.19,126.47,379.11,126.58Z"
          style={{ fill: '#e0e0e0' }}
        />
        <polygon
          points="410.57 125.02 456.5 136.15 449.99 167.63 402.63 155.33 410.57 125.02"
          style={{ fill: '#f5f5f5' }}
        />
        <path
          d="M456.5,136.15a3.06,3.06,0,0,1-.51.33l-1.5.85-5.58,3-18.62,10-.19.1-.13-.17-.63-.8L416,132.25c-1.66-2.18-3-4-4-5.26l-1.07-1.44a3.84,3.84,0,0,1-.35-.53,2.39,2.39,0,0,1,.43.46l1.15,1.39c1,1.27,2.41,3,4.13,5.15,3.48,4.44,8.23,10.47,13.47,17.14l.63.8-.33-.07,18.69-9.83,5.66-2.91,1.54-.76A2.05,2.05,0,0,1,456.5,136.15Z"
          style={{ fill: '#e0e0e0' }}
        />
        <path
          d="M402.63,155.33c-.08-.12,4.56-3.26,10.37-7s10.58-6.68,10.65-6.56-4.56,3.26-10.37,7S402.71,155.45,402.63,155.33Z"
          style={{ fill: '#e0e0e0' }}
        />
        <path
          d="M450,167.63c-.12.07-2.76-4.73-5.89-10.71S438.54,146,438.66,146s2.77,4.73,5.9,10.71S450.11,167.57,450,167.63Z"
          style={{ fill: '#e0e0e0' }}
        />
      </g>
      <g id="freepik--Plant--inject-107">
        <path
          d="M362.8,405.65l1.11.4c.72.28,1.82.65,3.28,1.06a38.71,38.71,0,0,0,13.11,1.33,52.77,52.77,0,0,0,9.44-1.52,59.87,59.87,0,0,0,10.73-3.74,65.81,65.81,0,0,0,21.88-16.72,20.43,20.43,0,0,0,4-6.68,10.44,10.44,0,0,0-.38-7.89,7.76,7.76,0,0,0-2.79-3,9.89,9.89,0,0,0-4-1.38,15.73,15.73,0,0,0-8.59,1.4,31.94,31.94,0,0,1-4.35,1.54,8.49,8.49,0,0,1-4.71-.12,5,5,0,0,1-3.4-3.32,5.86,5.86,0,0,1,.93-4.75,9,9,0,0,1,3.82-3.13,35.68,35.68,0,0,1,4.67-1.69,63.09,63.09,0,0,0,18.05-9.23,20.82,20.82,0,0,0,3.86-3.46,7.35,7.35,0,0,0,2-4.63,4.57,4.57,0,0,0-.73-2.4,5.61,5.61,0,0,0-1.87-1.75,11.73,11.73,0,0,0-5.07-1.42,30.35,30.35,0,0,1-5.47-.75,6.11,6.11,0,0,1-4.24-3.6,3.29,3.29,0,0,1,.35-2.89,7.26,7.26,0,0,1,2.16-1.91c1.56-1,3.1-2.09,4.59-3.23a73.62,73.62,0,0,0,8.46-7.56c2.6-2.77,5.24-5.65,6.87-9.13a11.46,11.46,0,0,0,1.18-5.53,8.46,8.46,0,0,0-2.17-5.16,11.24,11.24,0,0,0-10.41-3.42,18.37,18.37,0,0,0-9.72,5.62c-5.27,5.55-7.87,12.87-12.19,18.94a30.63,30.63,0,0,1-3.59,4.27,9.92,9.92,0,0,1-2.2,1.75,2.91,2.91,0,0,1-2.86.1,3.6,3.6,0,0,1-1.5-2.42,10.29,10.29,0,0,1,0-2.77,7.52,7.52,0,0,0-.1-2.6,4.72,4.72,0,0,0-1.26-2.18,6.47,6.47,0,0,0-4.64-1.83,7.32,7.32,0,0,0-4.58,2,11.6,11.6,0,0,0-2.9,4.13,19,19,0,0,0-1.24,4.91c-.21,1.68-.27,3.36-.33,5s-.11,3.35-.16,5q-.17,5-.33,9.82c-.06,1.61-.09,3.2-.17,4.81a15.61,15.61,0,0,1-.91,4.69,5.51,5.51,0,0,1-3.27,3.37,6.79,6.79,0,0,1-4.62-.3,18.39,18.39,0,0,1-7.14-5.4,19.76,19.76,0,0,1-2.38-3.68,39.07,39.07,0,0,0-2-3.75,5.86,5.86,0,0,0-3-2.54,5.45,5.45,0,0,0-3.85.27,7.84,7.84,0,0,0-3.05,2.37,9,9,0,0,0-1.56,3.47,54.38,54.38,0,0,0-.66,7.47c-.17,2.44-.25,4.83-.28,7.14a91.39,91.39,0,0,0,.79,13.06,64.1,64.1,0,0,0,2.43,11.1c.46,1.69,1.14,3.23,1.69,4.73.31.73.65,1.43,1,2.12s.61,1.37,1,2a42,42,0,0,0,7.9,10.56,14.19,14.19,0,0,0,1.47,1.35l1.11.94.88.77-.92-.73-1.12-.92a13.93,13.93,0,0,1-1.49-1.33,41.72,41.72,0,0,1-8-10.54,21.69,21.69,0,0,1-1-2c-.32-.69-.68-1.39-1-2.13-.56-1.5-1.25-3-1.72-4.73a63.69,63.69,0,0,1-2.47-11.15,88.74,88.74,0,0,1-.84-13.09c0-2.32.1-4.71.26-7.16a56.61,56.61,0,0,1,.65-7.54,9.4,9.4,0,0,1,1.62-3.61,8.15,8.15,0,0,1,3.19-2.49,5.82,5.82,0,0,1,4.13-.3,6.38,6.38,0,0,1,3.25,2.7,39.15,39.15,0,0,1,2,3.79,19,19,0,0,0,2.33,3.59,18.14,18.14,0,0,0,7,5.27,6.47,6.47,0,0,0,4.33.29,5.1,5.1,0,0,0,3-3.12c1.1-2.89.86-6.15,1-9.36s.21-6.5.32-9.81c.05-1.66.1-3.33.16-5s.11-3.39.33-5.09a19.11,19.11,0,0,1,1.26-5,12,12,0,0,1,3-4.31,7.85,7.85,0,0,1,4.89-2.09,6.94,6.94,0,0,1,5,2,5.18,5.18,0,0,1,1.39,2.41,7.8,7.8,0,0,1,.12,2.76,9.64,9.64,0,0,0,0,2.63,3,3,0,0,0,1.26,2.08,2.35,2.35,0,0,0,2.36-.11,9.66,9.66,0,0,0,2.09-1.66,31.58,31.58,0,0,0,3.52-4.2,108.79,108.79,0,0,0,5.71-9.62,45.54,45.54,0,0,1,6.53-9.39,18.83,18.83,0,0,1,10-5.77,11.76,11.76,0,0,1,10.9,3.59,9,9,0,0,1,2.3,5.47,12,12,0,0,1-1.23,5.78c-1.68,3.58-4.35,6.48-7,9.27a73.7,73.7,0,0,1-8.52,7.61c-1.5,1.15-3.05,2.23-4.62,3.25a6.74,6.74,0,0,0-2,1.76,2.76,2.76,0,0,0-.3,2.45,5.63,5.63,0,0,0,3.9,3.27,29,29,0,0,0,5.38.73,12.3,12.3,0,0,1,5.28,1.5,6.17,6.17,0,0,1,2,1.91,5.13,5.13,0,0,1,.81,2.66,7.87,7.87,0,0,1-2.09,5,21.26,21.26,0,0,1-4,3.53,63.69,63.69,0,0,1-18.19,9.29,34.14,34.14,0,0,0-4.62,1.66,8.45,8.45,0,0,0-3.63,3,5.41,5.41,0,0,0-.89,4.38,4.57,4.57,0,0,0,3.11,3,8,8,0,0,0,4.47.11,31.19,31.19,0,0,0,4.29-1.51,16.32,16.32,0,0,1,8.81-1.42,10.52,10.52,0,0,1,4.15,1.46,8.09,8.09,0,0,1,2.93,3.16,10.82,10.82,0,0,1,.38,8.2,20.66,20.66,0,0,1-4.08,6.8,65.84,65.84,0,0,1-22,16.74,59.72,59.72,0,0,1-10.79,3.72,53.86,53.86,0,0,1-9.48,1.49,38.62,38.62,0,0,1-13.16-1.44,33.76,33.76,0,0,1-3.27-1.11Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M368.39,393.45a295.29,295.29,0,0,1,12.91-31.24c1.28-2.7,2.55-5.38,3.81-8s2.49-5.23,3.87-7.71a148.28,148.28,0,0,1,8.71-13.76c3-4.24,6-8.16,8.79-11.8s5.52-7,8.11-9.92a117.21,117.21,0,0,1,13.24-12.95c1.68-1.4,3-2.45,3.93-3.14l1.05-.79a2.49,2.49,0,0,1,.37-.25l-.33.3-1,.83c-.89.73-2.2,1.8-3.86,3.23a124.21,124.21,0,0,0-13.07,13.06c-2.56,2.95-5.23,6.3-8,9.94s-5.76,7.58-8.73,11.82a149.15,149.15,0,0,0-8.64,13.72c-1.37,2.46-2.6,5.05-3.85,7.68l-3.8,8a299.47,299.47,0,0,0-12.93,31.16"
          style={{ fill: '#263238' }}
        />
        <path
          d="M389.15,346.48a7,7,0,0,1-.26-1.42c-.14-.91-.3-2.24-.46-3.89-.34-3.29-.65-7.84-1-12.87s-.7-9.57-1.08-12.84c-.19-1.64-.36-3-.49-3.88a5.67,5.67,0,0,1-.12-1.43,7.23,7.23,0,0,1,.36,1.39c.19.91.42,2.23.67,3.86.5,3.27.94,7.83,1.26,12.86s.59,9.45.8,12.88c.11,1.54.2,2.85.27,3.9A6.63,6.63,0,0,1,389.15,346.48Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M431.69,340.22a8.83,8.83,0,0,1-1.69.13c-1.09.06-2.66.13-4.61.28-3.88.27-9.23.82-15.11,1.7-5.21.78-10.28,1.71-15,2.76-1.9.42-3.43.79-4.49,1a9.58,9.58,0,0,1-1.67.35,7.88,7.88,0,0,1,1.61-.58c1-.32,2.56-.76,4.46-1.23,3.78-1,9.08-2.06,15-2.95a148.57,148.57,0,0,1,15.18-1.52c1.95-.1,3.53-.1,4.62-.08A7.87,7.87,0,0,1,431.69,340.22Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M368.94,392.69a2.1,2.1,0,0,1-.27-.52l-.66-1.56c-.57-1.35-1.35-3.33-2.27-5.79-1.85-4.92-4.19-11.79-6.67-19.41s-4.76-14.51-6.51-19.45c-.85-2.41-1.56-4.39-2.08-5.86-.22-.64-.41-1.16-.56-1.6a2.26,2.26,0,0,1-.16-.57,1.92,1.92,0,0,1,.27.53l.67,1.55c.57,1.36,1.34,3.34,2.26,5.8,1.85,4.91,4.2,11.79,6.68,19.41s5.75,15.6,7.5,20.55c.85,2.41.56,3.28,1.08,4.75.23.64.41,1.17.56,1.6A2.39,2.39,0,0,1,368.94,392.69Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M425.76,376.78a2.52,2.52,0,0,1-.57.21l-1.65.48-6.08,1.71c-5.14,1.45-12.21,3.54-20,5.85-7.31,2.16-14.11,4.12-20.08,5.67-2.58.68-4.68,1.2-6.14,1.53l-1.68.37a2.18,2.18,0,0,1-.59.09,2.28,2.28,0,0,1,.57-.21l1.65-.48,6.08-1.71c5.14-1.45,12.21-3.54,20-5.85s14.91-4.33,20.08-5.67c2.58-.68,4.68-1.2,6.13-1.53l1.68-.37A2.23,2.23,0,0,1,425.76,376.78Z"
          style={{ fill: '#263238' }}
        />
      </g>
      <g id="freepik--Character--inject-107">
        <path
          d="M260.78,162.41s-.58-2.78-1.55-10.82l-8.84-17.33s2-3.63,6.51,4.05c2.08,3.5,9,2,7.88-3.46s-8.28-8-12.66-2.56c0,0-2.83.29-3.16-1.92s6.06-7.67,11.5-6.08a16.5,16.5,0,0,1,6,3.4s-1.18-18.22.3-18.38,3.53,1,4.65,20.93c0,0,.62-15.77.93-17.78s3-3.37,3.36,1.68c0,.56,1,16.06,1,16.06s1.77-10.25,2-11.07c.5-2.16,2.63-1.93,2.84.93.15,2.17.85,11.43.85,11.43L283.73,160h.18"
          style={{ fill: '#ffbe9d' }}
        />
        <path
          d="M289.06,153l-33.2-.86-3.3,80.34L215,216l-.06.13c-2.26-1-4.23-1.9-5.28-2.48-20.75-11.31-34.37-12.69-56.64-4.74h0l-42.66,17.08c-8.26,3.89-29.75,7.48-37.12,41.46l-1,4.06L106.38,296l23.41,61.7,28,61.76,64.45-2.09,33.68-42-28.58-54.59-17.76-61.14c12.55,8.33,35.84,19.67,63.73,13.76C303.56,267,289.06,153,289.06,153Z"
          style={{ fill: '#95BD51' }}
        />
        <g style={{ opacity: '0.30000000000000004' }}>
          <path d="M129.57,357.07A65.36,65.36,0,0,0,146,364.2c3.14.94,6.74,1.63,9.53-.09s3.22-6.81.1-7.83l27.05-6.11c-3.67-10.56,2.38-22.61,11.53-29s19.55-8.25,30.69-9.22l13.49,41.85-45.09,61.5-36.92,1.07Z" />
        </g>
        <path
          d="M115.42,299.26s-16.91,37-13,55.44c2.16,10.32,35.93,19.13,57.45,21.76l-6.45,36.12s-80-7.61-94.95-39.28c-8.5-18,.11-62,16.3-111.8Z"
          style={{ fill: '#95BD51' }}
        />
        <path
          d="M192.44,342.59a2.89,2.89,0,0,1-.57.31l-1.69.78c-1.47.68-3.62,1.61-6.29,2.73-5.34,2.22-12.82,5.08-21.23,7.78s-16.16,4.72-21.8,6c-2.82.65-5.11,1.14-6.7,1.44l-1.83.34a2.59,2.59,0,0,1-.64.09,2.87,2.87,0,0,1,.62-.19l1.81-.44c1.58-.36,3.85-.91,6.66-1.6,5.61-1.39,13.32-3.47,21.72-6.16s15.88-5.49,21.25-7.63c2.69-1.06,4.85-1.94,6.35-2.56l1.72-.7A3.05,3.05,0,0,1,192.44,342.59Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M214.71,214.81c0,.13-31.47,11.56-70.39,25.52s-70.53,25.17-70.58,25,31.47-11.56,70.4-25.52S214.66,214.67,214.71,214.81Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M107.2,318a.91.91,0,0,1,.08-.22l.26-.62,1-2.39c.88-2.08,2.13-5.11,3.4-8.94A68.32,68.32,0,0,0,115,292a46.23,46.23,0,0,0-1.24-17.15,33.74,33.74,0,0,0-8.34-14.91,29,29,0,0,0-11.95-7.21,25,25,0,0,0-9.41-1l-1.49.19c-.43.06-.78.15-1.08.2l-.66.13-.23,0s.07,0,.21-.07l.66-.18c.29-.07.65-.18,1.08-.26l1.49-.23a24.27,24.27,0,0,1,9.53.85,28.94,28.94,0,0,1,12.19,7.22,34,34,0,0,1,8.5,15.11,46.2,46.2,0,0,1,1.22,17.34,67.26,67.26,0,0,1-3.2,13.87c-1.32,3.83-2.62,6.84-3.56,8.9-.48,1-.86,1.82-1.13,2.35l-.31.61C107.25,317.91,107.21,318,107.2,318Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M187.55,206.48a2.54,2.54,0,0,1,.57.25,12.76,12.76,0,0,1,1.55.91,21.14,21.14,0,0,1,4.83,4.51,32.81,32.81,0,0,1,4.74,8.58,112.68,112.68,0,0,1,3.47,11.47l5.57,21,1.62,6.39.42,1.74a2.54,2.54,0,0,1,.11.62,2.76,2.76,0,0,1-.21-.59c-.13-.45-.3-1-.51-1.72l-1.79-6.34-5.71-21c-1.1-4.1-2.11-8-3.42-11.44a33.52,33.52,0,0,0-4.58-8.52,22.32,22.32,0,0,0-4.65-4.57C188.3,206.91,187.52,206.52,187.55,206.48Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M242.85,228l-.44.21-1.33.58L236,230.93c-4.44,1.88-10.89,4.54-18.87,7.8-16,6.51-38.1,15.3-62.71,24.58s-47,17.31-63.33,23c-8.14,2.83-14.74,5.08-19.31,6.61l-5.27,1.75-1.37.44-.48.14.46-.19,1.36-.49,5.23-1.84,19.26-6.77c16.25-5.74,38.65-13.82,63.27-23.1s46.76-18,62.75-24.44l18.93-7.64,5.15-2.08,1.35-.53Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M213.57,267.87l-.38.18-1.14.49-4.41,1.83c-3.83,1.59-9.39,3.82-16.29,6.53-13.8,5.41-33,12.6-54.37,19.92s-41,13.37-55.19,17.54c-7.11,2.08-12.88,3.72-16.88,4.81l-4.6,1.25-1.2.31a2.18,2.18,0,0,1-.41.09,2.67,2.67,0,0,1,.39-.14l1.19-.36L64.86,319c4-1.15,9.73-2.85,16.83-5,14.19-4.25,33.73-10.36,55.12-17.67s40.58-14.45,54.41-19.78c6.91-2.66,12.49-4.84,16.34-6.37l4.45-1.74,1.16-.44Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M291.75,233.25a4.39,4.39,0,0,1-.58.5l-1.75,1.36c-.76.59-1.7,1.3-2.81,2.09s-2.36,1.72-3.79,2.67c-2.83,1.95-6.28,4.16-10.19,6.48s-8.31,4.71-13,7-9.31,4.28-13.53,6-8.1,3-11.38,4.05c-1.63.54-3.13,1-4.44,1.35s-2.44.7-3.37.93l-2.15.55a4.69,4.69,0,0,1-.75.15,4.24,4.24,0,0,1,.72-.26l2.12-.63c.92-.27,2-.6,3.35-1s2.78-.85,4.4-1.42c3.26-1.08,7.1-2.48,11.32-4.15s8.78-3.69,13.48-6,9.08-4.69,13-7,7.37-4.47,10.22-6.38c1.44-.93,2.7-1.83,3.83-2.6s2.08-1.45,2.86-2l1.8-1.28A4,4,0,0,1,291.75,233.25Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M293.31,206.57c.05.14-9.13,3.83-20.5,8.25s-20.64,7.89-20.69,7.75,9.12-3.82,20.5-8.24S293.26,206.44,293.31,206.57Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M291.29,181.69c0,.14-8,2.55-18,5.38s-18.11,5-18.15,4.87,8-2.54,18-5.37S291.25,181.55,291.29,181.69Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M289.53,157.35c0,.14-7.77,2-17.42,4.09s-17.49,3.73-17.52,3.59,7.76-2,17.41-4.09S289.49,157.21,289.53,157.35Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M219.87,295.4c0,.13-22.2,9-49.69,19.86s-49.83,19.52-49.88,19.39,22.19-9,49.69-19.87S219.82,295.26,219.87,295.4Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M102.23,339.43a2.23,2.23,0,0,1-.45.22l-1.34.55c-1.17.46-2.87,1.11-5,1.89-4.22,1.56-10.09,3.61-16.63,5.69s-12.52,3.81-16.86,5c-2.17.58-3.94,1-5.16,1.34l-1.41.33a1.67,1.67,0,0,1-.5.08,1.82,1.82,0,0,1,.47-.18l1.39-.43,5.11-1.5c4.31-1.26,10.26-3,16.8-5.12s12.41-4.08,16.66-5.55l5-1.73,1.37-.46A1.58,1.58,0,0,1,102.23,339.43Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M114.1,364.77c.06.13-10.72,4.63-24.07,10.05s-24.23,9.71-24.28,9.58,10.72-4.64,24.08-10.06S114.05,364.63,114.1,364.77Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M133.73,371.77c.11.1-5.94,7.26-13.5,16s-13.79,15.75-13.9,15.66,5.94-7.26,13.5-16S133.62,371.68,133.73,371.77Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M153.8,376.87c.14.05-2.29,7.67-5.42,17s-5.78,16.91-5.91,16.86,2.29-7.66,5.42-17S153.66,376.82,153.8,376.87Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M285,264.35c.06.13-5.69,2.51-12.84,5.31s-13,4.95-13,4.82,5.7-2.51,12.85-5.31S284.94,264.21,285,264.35Z"
          style={{ fill: '#fff' }}
        />
        <g style={{ opacity: '0.30000000000000004' }}>
          <path d="M199.65,222.57c9.28,25.13,26,39.18,49.61,51.78a87.07,87.07,0,0,1-39-14.29" />
        </g>
        <path
          d="M191.24,423H369.37V346.9a25.81,25.81,0,0,0-25.81-25.82H217.06a25.82,25.82,0,0,0-25.82,25.82Z"
          style={{ fill: '#455a64' }}
        />
        <path
          d="M214.33,321.08h28.3a10.46,10.46,0,0,1,10.46,10.46v90.13a1.33,1.33,0,0,1-1.33,1.33H192.58a1.33,1.33,0,0,1-1.33-1.33V344.17A23.09,23.09,0,0,1,214.33,321.08Z"
          style={{ fill: '#455a64' }}
        />
        <path
          d="M204.38,423V346.79a25.71,25.71,0,0,1,25.7-25.71H211.76s-21.51,2.86-21.51,29.78.69,72.14.69,72.14Z"
          style={{ fill: '#263238' }}
        />
        <rect
          x="103.64"
          y="415.76"
          width="149.45"
          height="8.48"
          style={{ fill: '#263238' }}
        />
        <rect
          x="253.09"
          y="415.76"
          width="122.1"
          height="8.48"
          style={{ fill: '#455a64' }}
        />
        <path
          d="M253.09,420a1.16,1.16,0,0,1,0-.3c0-.23,0-.53,0-.9,0-.82,0-2,0-3.43,0-3,0-7.31,0-12.61.05-10.69.13-25.38.22-41.62,0-4.06.13-8-.12-11.84a42.56,42.56,0,0,0-1.92-10.78,24.94,24.94,0,0,0-23.45-17.21,17.37,17.37,0,0,0-2,.05,12.1,12.1,0,0,0-1.44.14l-.88.12-.31,0,.3-.07.88-.17a10.59,10.59,0,0,1,1.44-.19,14.68,14.68,0,0,1,2-.1,25,25,0,0,1,12.16,3.09,24.17,24.17,0,0,1,11.75,14.16,43.31,43.31,0,0,1,2,10.91c.25,3.84.17,7.82.13,11.88-.15,16.23-.28,30.93-.38,41.61-.07,5.3-.13,9.6-.17,12.62,0,1.46-.06,2.61-.07,3.43l0,.89A1.71,1.71,0,0,1,253.09,420Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M374.35,415.55c0,.14-27.82.31-62.12.37s-62.12,0-62.12-.16,27.8-.31,62.12-.37S374.35,415.41,374.35,415.55Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M374.35,424.58c0,.14-27.62.18-61.67.09s-61.68-.28-61.67-.43,27.6-.18,61.67-.09S374.35,424.43,374.35,424.58Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M358.27,406.08s0-.13,0-.36,0-.6,0-1.05c0-.93,0-2.28,0-4,0-3.51-.05-8.62-.08-15.08l.15.16-79.93.1c.11-.11-.27.26.25-.26h0v20.5l-.26-.25,57,.11,16.81.07,4.54,0h1.18l.41,0a2.45,2.45,0,0,1-.38,0h-1.15l-4.48,0-16.75.07-57.18.12h-.25v-.26q0-5,0-10.1v-10.4h0c.52-.52.15-.14.27-.26l79.93.1h.16v.16c0,6.5-.07,11.64-.09,15.18q0,2.6,0,4c0,.43,0,.77,0,1A1.91,1.91,0,0,1,358.27,406.08Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M313.13,390.85V400h-.93v-7.3l-3.58,6.14h-.46l-3.58-6.1V400h-.92v-9.12h.79l4,6.76,3.92-6.76Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M321.82,397.53h-5.08l-1.1,2.44h-1l4.17-9.12h.95l4.17,9.12h-1Zm-.35-.78-2.19-4.9-2.19,4.9Z"
          style={{ fill: '#263238' }}
        />
        <path d="M325.44,390.85h1V400h-1Z" style={{ fill: '#263238' }} />
        <path
          d="M329.38,390.85h1v8.28h5.11V400h-6.07Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M348,300.22v-15H320v60.14a11.88,11.88,0,1,0,11.51-.32V300.22Z"
          style={{ fill: '#95BD51' }}
        />
        <circle cx="326.34" cy="355.4" r="4.58" style={{ fill: '#263238' }} />
        <path
          d="M154.29,209.28a4.11,4.11,0,0,1,.26.61,16,16,0,0,1,.59,1.83,22.67,22.67,0,0,1,.68,7,23.16,23.16,0,0,1-2.91,10,20.89,20.89,0,0,1-9.35,8.63,19.68,19.68,0,0,1-12.62,1.5,21,21,0,0,1-9.25-4.8,21.38,21.38,0,0,1-4.41-5.51,15.87,15.87,0,0,1-.84-1.72,2.76,2.76,0,0,1-.23-.63c.06,0,.39.84,1.25,2.25a22.2,22.2,0,0,0,4.47,5.33,20.84,20.84,0,0,0,9.11,4.61,19.33,19.33,0,0,0,12.3-1.51,20.62,20.62,0,0,0,9.16-8.39,23.19,23.19,0,0,0,2.95-9.81,23.55,23.55,0,0,0-.51-6.94C154.58,210.15,154.23,209.3,154.29,209.28Z"
          style={{ fill: '#263238' }}
        />
        <polygon
          points="239.41 364.08 253.06 363.9 252.53 410.27 239.86 410.77 239.41 364.08"
          style={{ fill: '#ebebeb' }}
        />
        <path
          d="M239.86,410.77a81.14,81.14,0,0,1,6-6.91,79.89,79.89,0,0,1,6.44-6.56,84.76,84.76,0,0,1-6.06,6.91A82.82,82.82,0,0,1,239.86,410.77Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M253.06,379.52a102.09,102.09,0,0,1-7-7.42,98.26,98.26,0,0,1-6.63-7.76,99.62,99.62,0,0,1,7,7.42A100.92,100.92,0,0,1,253.06,379.52Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M137.15,160.7a3.6,3.6,0,0,0,6.08,2.61c1.93-1.83,1.27-5.05.07-7.43s-2.86-4.79-2.51-7.42c.27-2,1.67-3.67,2.61-5.48a11.47,11.47,0,0,0,.25-10.24,9.67,9.67,0,0,0-8.55-5.35c-3.61.07-7.42,2.33-10.63.67-2.33-1.21-3.3-4-5.33-5.72-3.13-2.59-7.86-1.73-11.57,0s-7.26,4.12-11.33,4.32c-3.39.16-6.65-1.26-10-1.72A17.82,17.82,0,0,0,71.06,155a11.37,11.37,0,0,0,6.87,3.64"
          style={{ fill: '#263238' }}
        />
        <path
          d="M141.68,237.12h0a20.24,20.24,0,0,1-25.54-12.83c-2-6.06-3.71-11.16-3.71-11.16s-16.1,2.46-21.14-12.83-13-49.31-13-49.31l-.49-2.06c15.36-13.25,37.2-15.46,56.25-8.51l1,3.17,20,69.31A20.24,20.24,0,0,1,141.68,237.12Z"
          style={{ fill: '#ffbe9d' }}
        />
        <path
          d="M91.76,173.54a2.36,2.36,0,0,0-1.16-4.25,2.16,2.16,0,0,0-1.59.44A2.36,2.36,0,0,0,90.16,174,2.17,2.17,0,0,0,91.76,173.54Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M85.37,171.62c.33.19,1.47-1.45,3.58-2.13s4-.07,4.13-.41c.08-.16-.31-.56-1.14-.86a5.46,5.46,0,0,0-6.16,2C85.29,171,85.22,171.54,85.37,171.62Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M111.17,165a2.34,2.34,0,1,0,3.3-.24A2.35,2.35,0,0,0,111.17,165Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M108.37,166.47c.32.19,1.46-1.44,3.57-2.12s4-.07,4.14-.42c.08-.15-.31-.56-1.14-.85a5.46,5.46,0,0,0-6.16,2C108.29,165.84,108.21,166.39,108.37,166.47Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M105.4,186.59c0-.16-1.43,0-3.64.38-.57.12-1.06.14-1.21-.17a3,3,0,0,1-.11-1.72c.1-1.56.2-3.16.31-4.83.37-6.85.41-12.41.09-12.43s-.9,5.52-1.28,12.37c-.08,1.67-.15,3.26-.22,4.83a3.65,3.65,0,0,0,.42,2.37,1.47,1.47,0,0,0,1.2.57,3.61,3.61,0,0,0,1-.17C104.11,187.2,105.43,186.75,105.4,186.59Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M113,186.76c1.79-2-5,5.13-9.41,6.28a6.12,6.12,0,0,0,7.63.15C115.28,190.06,113,186.76,113,186.76Z"
          style={{ fill: '#fff' }}
        />
        <path
          d="M112.34,212.92a37.45,37.45,0,0,0,18.21-12s-1.24,12.54-17,16Z"
          style={{ fill: '#eb996e' }}
        />
        <path
          d="M137.27,154.07c.31-.22,11.17-4.48,13.42,9.05s-12.16,11.31-12.25,10.93S137.27,154.07,137.27,154.07Z"
          style={{ fill: '#ffbe9d' }}
        />
        <path
          d="M141.8,168.62c0-.06.26.12.69.24a2.42,2.42,0,0,0,1.77-.26c1.34-.76,2.16-3.23,1.83-5.67a8,8,0,0,0-1.22-3.27,2.77,2.77,0,0,0-2.08-1.51,1.21,1.21,0,0,0-1.28.88c-.12.4,0,.66,0,.69s-.33-.17-.32-.75a1.58,1.58,0,0,1,.4-.94,1.82,1.82,0,0,1,1.24-.56,3.37,3.37,0,0,1,2.81,1.69A8.16,8.16,0,0,1,147,162.8c.37,2.73-.6,5.52-2.46,6.4a2.53,2.53,0,0,1-2.22,0C141.88,168.94,141.76,168.65,141.8,168.62Z"
          style={{ fill: '#eb996e' }}
        />
        <path
          d="M76.53,158.41s10.61,1.91,21.08-7.57c6.86-6.22,15.62-10.78,18.13-9.75s5.23,9.14,13.82,9.32c0,0,3.85,15.85,9.95,13.54s-4.62-25.53-4.62-25.53l-17.21-6.31-17.59,1.53-17.86,7.21-8.7,9.28Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M132.33,125a16.51,16.51,0,0,0-3.26,1.65,16,16,0,0,0-2.47,2.7,6.05,6.05,0,0,1,5.73-4.35Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M124.16,120.61a4,4,0,0,1,.72,1.32,14.58,14.58,0,0,1,1,3.5,10.17,10.17,0,0,1-.1,3.64,3.18,3.18,0,0,1-.52,1.42,20.83,20.83,0,0,0,.1-5C124.94,122.77,124,120.67,124.16,120.61Z"
          style={{ fill: '#263238' }}
        />
        <polygon
          points="165.26 363.38 234.51 350.5 244.86 397.3 172.94 409.44 165.26 363.38"
          style={{ fill: '#e0e0e0' }}
        />
        <path
          d="M234.51,350.5s0,.07-.12.19l-.39.55-1.54,2.06-5.76,7.53c-4.94,6.38-11.72,15.15-19.27,24.89l-.13.17-.19-.1-1.35-.71-28.69-15.25-8.66-4.68-2.35-1.29-.6-.35a.93.93,0,0,1-.2-.14l.22.09.63.3L168.5,365c2.11,1.09,5.08,2.64,8.75,4.53L206,384.62l1.34.71-.33.07,19.39-24.79,5.89-7.44c.69-.84,1.23-1.51,1.62-2,.18-.2.32-.37.43-.51Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M172.94,409.44c-.12-.08,4.33-7.14,9.95-15.77s10.26-15.57,10.38-15.49-4.33,7.14-10,15.77S173.06,409.52,172.94,409.44Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M244.86,397.3c-.09.11-6.57-4.85-14.47-11.08s-14.23-11.37-14.14-11.48,6.56,4.84,14.47,11.07S245,397.18,244.86,397.3Z"
          style={{ fill: '#263238' }}
        />
        <path
          d="M167.08,373.82s.49,9.07,4.86,9,19.79-8.49,21.58-5.57-2.94,7-2.94,7,5.43-.08,3.41,3.17-8.07,18.47-13.66,19.9c-8,2.05-26.53,2.85-26.53,2.85l5.71-31.87Z"
          style={{ fill: '#ffbe9d' }}
        />
        <path
          d="M192.26,382.28a3.7,3.7,0,0,1-.58.65c-.4.39-1,.94-1.76,1.58a49.55,49.55,0,0,1-13.35,8c-.93.37-1.69.64-2.22.81a3,3,0,0,1-.85.21,26.54,26.54,0,0,1,2.93-1.36,66.35,66.35,0,0,0,13.26-8A25.61,25.61,0,0,1,192.26,382.28Z"
          style={{ fill: '#eb996e' }}
        />
        <path
          d="M192,391.26a9.91,9.91,0,0,1-1.59,2.28,25.53,25.53,0,0,1-11,7.58,10.24,10.24,0,0,1-2.7.69,23.87,23.87,0,0,1,2.57-1,30,30,0,0,0,10.81-7.48A26.9,26.9,0,0,1,192,391.26Z"
          style={{ fill: '#eb996e' }}
        />
      </g>
    </svg>
  );
};

export default WelcomeIcon;

WelcomeIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
